<template>
  <div>
    <!-- <div
      class="cursor-pointer flex items-center rounded-xl"
      @click="showTokenModal = true"
    > -->
    <div class="cursor-pointer flex items-center rounded-xl">
      <div class="font-medium">{{ token }}</div>
      <svg
        class="h-2 ml-2"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12.814 6.907"
        enable-background="new 0 0 12.814 6.907"
        xml:space="preserve"
      >
        <!-- <path
          fill="#231F20"
          d="M0.146,0.854c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0L5.907,5.2l0.499,0.464l0.5-0.464 l5.055-5.054c0.195-0.195,0.512-0.195,0.707,0s0.195,0.512,0,0.707L6.762,6.761C6.715,6.807,6.658,6.844,6.598,6.868 C6.537,6.894,6.473,6.907,6.406,6.907c-0.064,0-0.129-0.014-0.189-0.039C6.154,6.844,6.1,6.807,6.053,6.761L0.146,0.854"
        /> -->
      </svg>
    </div>
    <SelectTokenModal
      :userAction="userAction"
      v-if="showTokenModal"
      @close="updateTokenDisplay"
    />
  </div>
</template>



<script>
import axios from "axios";
import SelectTokenModal from "@/components/cas/SelectTokenModal";
export default {
  name: "SelectTokenInput",
  components: { SelectTokenModal },
  props: { userAction: String },
  data: function () {
    return {
      nftValue: 0,
      token: "ETH",
      showTokenModal: false,
    };
  },
  beforeMount: async function () {},
  methods: {
    updateTokenDisplay: async function () {
      this.showTokenModal = false;
      if (
        this.userAction == "deposit" &&
        this.$store.state.tokenSelected.type == "token"
      ) {
        this.token = this.$store.state.tokenSelected.token;
      } else {
        this.token = "ETH";
      }
    },
  },
  mounted: async function () {
    this.updateTokenDisplay();
  },
  computed: {},
};
</script>
